const manageInquiry = {
  manageInquiry: {
    pageTitle: '문의 관리',
    description: '문의사항을 관리하고 답변을 작성할 수 있습니다.',
    filters: {
      status: '상태',
      inquiryType: '문의 유형',
      category: '분류',
      search: '검색',
      searchPlaceholder: '작성자, 이메일..',
      options: {
        all: '전체',
        // status
        pending: '답변 대기',
        completed: '답변 완료',
        // inquiry type
        useGroundStation: '지상국 사용 문의',
        shareGroundStation: '지상국 공유 제안',
        estimateInquiry: '견적 요청',
        pressInquiry: '보도/언론 문의',
        other: '기타',
        // writer type
        member: '회원',
        guest: '비회원'
      }
    },
    buttons: {
      reset: '초기화',
      delete: '삭제 ({{count}})',
      deleteConfirm: '삭제',
      cancel: '취소',
      ok: '확인'
    },
    totalCount: '총 {{count}}개',
    deleteModal: {
      title: '문의 삭제',
      body: '선택된 {{count}}개의 문의를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.'
    },
    alertModal: {
      titleSuccess: '성공',
      titleWarning: '경고',
      titleError: '오류'
    },
    alerts: {
      selectItemToDelete: '삭제할 항목을 선택해주세요.',
      loadFailed: '문의 목록을 불러오는데 실패했습니다.',
      deleteSuccess: '선택된 문의가 삭제되었습니다.',
      deleteFailed: '문의 삭제에 실패했습니다.'
    }
  }
};

export default manageInquiry;